/**
 * Visually Utility JavaScript
 *
 * This file contains utility functions for the Visually experiment framework.
 */

/**
 * Waits for the experimentAPI to be available, with a timeout.
 *
 * @param {number} timeout - Maximum time to wait in milliseconds (default: 5000ms)
 * @param {number} checkInterval - Interval between checks in milliseconds (default: 100ms)
 * @returns {Promise<object|null>} - Resolves with experimentAPI if found, or null if timeout
 */
function waitForExperimentAPI(timeout = 5000, checkInterval = 100) {
    return new Promise((resolve) => {
        if (typeof experimentAPI !== 'undefined') {
            resolve(experimentAPI);
            return;
        }

        const startTime = Date.now();

        const checkForAPI = setInterval(() => {
            if (typeof experimentAPI !== 'undefined') {
                clearInterval(checkForAPI);
                resolve(experimentAPI);
                return;
            }

            if (Date.now() - startTime >= timeout) {
                clearInterval(checkForAPI);
                resolve(null);
            }
        }, checkInterval);
    });
}

/**
 * Dispatches a variant change event with the variant from variantsFilterFn on document load.
 * This function waits for the experimentAPI to be available before dispatching the event.
 * Uses async/await for better readability and error handling.
 */
function changeVariantOnExperimentAPILoad() {
    document.addEventListener('DOMContentLoaded', async () => {
        await waitForExperimentAPI();
        if (typeof experimentAPI !== 'undefined') {

            const variant = variantsFilterFn(window.variantsData, countryIsoCode, marketISO, blockedCountries, true);

            if (variant) {
                const input = document.querySelector(`input[value="${variant.id}"]`);
                if (input) {
                    document.querySelector(`label[for='${input.id}']`)?.click();
                }
            }
        }
    });
}

changeVariantOnExperimentAPILoad();

function handlePDPScarcity(stockStatus, variantsStockDisplay) {

    const stockScarcityContainers = document.querySelectorAll('.stock-scarcity');
    stockStatus.classList.toggle('hidden', true);
    for (const stockScarcityContainer of stockScarcityContainers) {
        stockScarcityContainer.classList.toggle('hidden', false);
        const stockScarcityText = stockScarcityContainer.querySelector('span');
        stockScarcityText.innerHTML = `Only ${variantsStockDisplay} Left!`;
        pulseElement(stockScarcityText);
    }

    function pulseElement(element) {
        element.classList.add('animate__animated', 'animate__pulse');
        element.addEventListener('animationend', () => {
            element.classList.remove('animate__animated', 'animate__pulse');
        }, {once: true});
    }
}
